
































































































































import mixins from 'vue-typed-mixins'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import { ETariffName, ModalParams, EModalStep } from '@/models/billing'
import ImgBlock from '@/components/Billing/ImgBlock.vue'
import {
  ScriptRowDesktop,
  ScriptRowTablet,
  ScriptRowMobile,
} from '@/components/Scripts/ScriptRow/ScriptRow'
import moneyDollar from '@/assets/svg/rounded/money-dollar.svg?inline'
import gift from '@/assets/svg/rounded/gift.svg?inline'
import barChart from '@/assets/svg/rounded/bar-chart-1.svg?inline'
import archive from '@/assets/svg/rounded/archive-1.svg?inline'
import knowledge from '@/assets/svg/rounded/knowledge.svg?inline'
import headsetMic from '@/assets/svg/rounded/headset-mic-1.svg?inline'
import dollar from '@/assets/svg/rounded/dollar.svg?inline'
import addBrowser from '@/assets/svg/rounded/add-browser.svg?inline'
import file from '@/assets/svg/rounded/file.svg?inline'
import barChart2 from '@/assets/svg/rounded/bar-chart2.svg?inline'
import scriptIcon from '@/assets/svg/rounded/script.svg?inline'
import userGroup from '@/assets/svg/rounded/user-group.svg?inline'
import { Modals } from '@/constants/modals'

interface Data {
  tariffsName: { [key in ETariffName]: ETariffName }
}

interface Methods {
  handleOpenModal: () => void
  handleOpenCarrotQuestChat: () => void
}

interface Computed {
  currentBreakPoint: string
}

export default mixins(WindowResizeListener).extend<Data, Methods, Computed, {}>(
  {
    components: {
      ScriptRowDesktop,
      ScriptRowTablet,
      ScriptRowMobile,
      ImgBlock,
      moneyDollar,
      gift,
      barChart,
      archive,
      knowledge,
      headsetMic,
      dollar,
      addBrowser,
      file,
      scriptIcon,
      userGroup,
      barChart2,
    },
    data() {
      return {
        tariffsName: ETariffName,
      }
    },
    methods: {
      handleOpenModal() {
        this.$modal.hide(Modals.TariffsModal)
        setTimeout(() => {
          this.$modal.show(Modals.PaymentModal, {
            modalStep: EModalStep.tariffs,
            enableMonths: true,
            enableUsers: true,
          } as ModalParams)
        }, 500)
      },
      handleOpenCarrotQuestChat() {
        window.carrotquest?.open()
      },
    },
    computed: {
      currentBreakPoint() {
        if (this.isDesktop) {
          return 'is-desktop'
        }
        if (this.isTablet) {
          return 'is-tablet'
        }
        return 'is-mobile'
      },
    },
  },
)
